import { useContext } from 'react';
import { HomeProviderContext } from '../context/HomeProvider/HomeContextProvider';

const useHomeContext = () => {
  return useContext(HomeProviderContext);
};

export default useHomeContext;
